import IconWrapper from './IconWrapper';

const IconCegid = IconWrapper({
  name: 'cegid',
  source: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="300.000000pt"
      height="300.000000pt"
      viewBox="0 0 300.000000 300.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" stroke="none">
        <path d="M125 2985 c-50 -18 -100 -71 -114 -122 -15 -55 -15 -2673 0 -2728 14 -51 73 -110 124 -124 56 -15 2674 -15 2730 0 51 14 110 73 124 124 15 56 15 2674 0 2730 -14 51 -73 110 -124 124 -28 8 -429 11 -1370 11 -1120 -1 -1336 -3 -1370 -15z m1831 -470 c96 -17 241 -63 315 -101 l47 -23 -80 -198 c-44 -109 -82 -200 -84 -202 -2 -2 -46 10 -98 28 -413 137 -773 -27 -841 -382 -54 -282 50 -540 259 -642 100 -49 181 -67 305 -68 119 0 200 17 300 63 35 17 66 30 70 30 4 0 45 -79 91 -175 68 -143 81 -177 71 -189 -17 -20 -202 -110 -278 -135 -209 -69 -493 -68 -702 4 -462 157 -729 631 -646 1144 72 440 393 766 833 845 106 19 329 20 438 1z" />
      </g>
    </svg>
  ),
});

export default IconCegid;
